import React from "react";
import { PageHeader } from "./../Components";
import AnnouncementItemImg from "./../media/announcement_item.jpg";
export default class PersonalBanking extends React.PureComponent {
  state = {
    items: [1, 2, 3, 4, 5]
  };
  render = () => (
    <div>
      <PageHeader headerClass={"announcements"} pageName="Duyurular" />
      <div className="container announcement mt80 mb80">
        {this.state.items.map(item => (
          <div key={item} className="announcement_item">
            <div className="col-8">
              <p className="title">NovaBank Lefokoşa’da İkinci Şubeyi Açtı</p>
              <p className="date">21.12.2015</p>
              <p className="sub_title">
                NovaBank’ın dördüncü şubesi Lefkoşa Ortaköy’de bulunan Gazeteci
                Hasan Tahsin Caddesi Lemar Alışveriş Merkezi yanında hizmete
                açıldı. Açılışa Levent Şirketler Grubu Yönetim Kurulu Başkanı
                Özer Boyacı’nın yanı sıra NovaBank Yönetim Kurulu Başkanı Mehmet
                Boyacı, Yönetim Kurulu Başkan...
              </p>
              <p className="sub_title">
                NovaBank’ın dördüncü şubesi Lefkoşa Ortaköy’de bulunan Gazeteci
                Hasan Tahsin Caddesi Lemar Alışveriş Merkezi yanında hizmete
                açıldı. Açılışa Levent Şirketler Grubu Yönetim Kurulu Başkanı
                Özer Boyacı’nın yanı sıra NovaBank Yönetim Kurulu Başkanı Mehmet
                Boyacı, Yönetim Kurulu Başkan...
              </p>
            </div>
            <div className="col-4">
              <img
                alt=""
                className="item_thumbnail"
                src={AnnouncementItemImg}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
